export { SmsfTile, type SmsfTileProps } from './SmsfTile';
